<script lang="ts">
  import ChatWithSupportLink from "./ChatWithSupportLink.svelte";

  export let title: string | null = null;

</script>

<div class="fizz-inset-square-16 fizz-text-large fizz-stack-16 fizz-text-left">
  {#if title}
    <h2 class="fizz-heading-2 fizz-stack-8">{title}</h2>
  {/if}
  <div
    class="fizz-stack-16"
    class:fizz-border-bottom={title}
    data-testid="no-available-products-help-text"
  />
  There are no products available. Reach out to &nbsp;<ChatWithSupportLink
    message="Customer Support"
  /> for help.
</div>
